import React, { useContext, useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import { Navbar } from "../../components/Navbar/Navbar";
import "./topic-analysis.scss";
import AuthContext from "../../context/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import {getQuestionAnalysis, getQuestionTopicAnalysis} from "../../store/actions/examActions";
import { GhostExamListLoader } from "../../components/Loaders/GhostExamListLoader";
import { ExamAnalysis } from "../../components/Exams/ExamAnalysis";
import { useMediaQuery } from "react-responsive";
import { GhostExamListMobileLoader } from "../../components/Loaders/GhostExamListMobileLoader";
import { ExamCardAnalysis } from "../../components/Exams/ExamCardAnalysis";
import {setGlobalAnalysisFilter, setGlobalEmailAnalysisFilter} from "../../store/slices/adminSlice";
import {AnalysisTFilter} from "./AnalysisT/AnalysisTFilter";
import {setGlobalAnalysisTFilter} from "../../store/slices/examSlice";
import {TopicColAnalysis} from "./AnalysisT/TopicColAnalysis";

export const TopicAnalysis = ({ isAdmin, isBusiness }) => {
  const useDesktopMediaQuery = () =>
    useMediaQuery({ query: "(min-width: 769px)" });

  const useTabletAndBelowMediaQuery = () =>
    useMediaQuery({ query: "(max-width: 768px)" });

  const Desktop = ({ children }) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
  };

  const TabletAndBelow = ({ children }) => {
    const isTabletAndBelow = useTabletAndBelowMediaQuery();
    return isTabletAndBelow ? children : null;
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleSetShow = () => setShow(true);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 100;
  const modeData = ["Test", "Email"];
  const [sort, setSort] = useState("");
  const [mode, setMode] = useState("Test");
  const { user, isLoggedIn } = useContext(AuthContext);
  const { analysisTdata } = useSelector((state) => state.exam);
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState({ search: "" });

  const handleGoToNext = (page) => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleGoToPrev = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleResetCurrentPage = () => {
    setCurrentPage((prev) => 1);
  };


  const handleReset = () => {
    const payload = {
      typeFilter: "",
      yearFilter: "",
      subjectFilter: "",
    };
    dispatch(setGlobalAnalysisTFilter(payload));
    handleSearch();
  }
  const handleSearch = () => {
    const data = { pageSize, currentPage, sort };

    data.isSearch = true;
    // if (filterData.search.length > 0) data.search = filterData.search;
    handleApiData(data);
  };

  const handleApiData = (data) => {
    const filters = JSON.parse(localStorage.getItem(`analysisTFilters`) || "{}");

    if (filters.subjectFilter && filters.subjectFilter.length > 0) {
      data.subject = filters.subjectFilter;
    }

    if (filters.typeFilter && filters.typeFilter.length > 0) {
      data.type = filters.typeFilter;
    }
    if (filters.yearFilter && filters.yearFilter.length > 0) {
      data.year = filters.yearFilter;
    }
    if (filters.testFilter) {
      data.testFilter = filters.testFilter;
    }
    if (filters.modeFilter) {
      data.modeFilter = filters.modeFilter;
    }
    if (data.isSearch) {
      handleResetCurrentPage();
      data.currentPage = 1;
    }
    dispatch(getQuestionTopicAnalysis(data));
  };

  useEffect(() => {
    handleApiData({ pageSize, currentPage, sort });
  }, [pageSize, currentPage]);

  useEffect(() => {
    return () => {
      const payload = {
        typeFilter: "",
        yearFilter: "",
        subjectFilter: "",
      };
      dispatch(setGlobalAnalysisTFilter(payload));
    };
  }, []);

  return (
    <>
      <div>{ <Navbar />}</div>
      <Desktop>
        <div className="topic-analysis-div col-md-10 offset-md-1">
          <div className="flexy flexyM search-bar mt6">
            <div className="lisxt ">{<h5>Topic List</h5>}</div>
          </div>
          {!analysisTdata.loading && analysisTdata.topics && (
            <>
              <AnalysisTFilter
                handleClose={handleClose}
                show={show}
                Desktop={Desktop}
                TabletAndBelow={TabletAndBelow}
                handleSearch={handleSearch}
              />
            </>
          )}
          {analysisTdata.loading &&
            Array(pageSize)
              .fill()
              .map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <GhostExamListLoader></GhostExamListLoader>
                  </React.Fragment>
                );
              })}
          {!analysisTdata.loading &&
          analysisTdata.topics && (
            <TopicColAnalysis
              globalFilter={filterData}
              onGlobalFilterChange={handleSearch}
              data={analysisTdata.topics}
              meta={analysisTdata.topicMeta}
              mode={mode}
              onGotoNextPage={handleGoToNext}
              onGotoPrevPage={handleGoToPrev}
              currentPage={currentPage}
            />
          )}
        </div>
      </Desktop>
      <TabletAndBelow>
        <div className="mobile-ms topic-analysis-div ">
          {!analysisTdata.loading && analysisTdata.topics && (
              <>
                <AnalysisTFilter
                    handleClose={handleClose}
                    handleReset={handleReset}
                    Desktop={Desktop}
                    TabletAndBelow={TabletAndBelow}
                    handleSearch={handleSearch}
                />
              </>
          )}
          {analysisTdata.loading &&
            Array(pageSize)
              .fill()
              .map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <GhostExamListMobileLoader></GhostExamListMobileLoader>
                  </React.Fragment>
                );
              })}
          {!analysisTdata.loading &&
          analysisTdata.topics && (
            <TopicColAnalysis
                globalFilter={filterData}
                onGlobalFilterChange={handleSearch}
                data={analysisTdata.topics}
                meta={analysisTdata.topicMeta}
                mode={mode}
                onGotoNextPage={handleGoToNext}
                onGotoPrevPage={handleGoToPrev}
                currentPage={currentPage}
            />
          )}
        </div>
      </TabletAndBelow>
    </>
  );
};
